export enum PlansTabField {
  BillingOptions = 'billingOptions',
  BillingMonthlyEnabled = 'billingOptions.monthlyEnabled',
  BillingAnnualEnabled = 'billingOptions.annualEnabled',
  Plans = 'plans',
  Features = 'features',
  Options = 'options',
  OptionsShowFaq = 'options.showFaq',
  OptionsFaqQuestions = 'options.faqQuestions',
  OptionsShowSkipPriceSelection = 'options.showSkipPriceSelection',
  OptionsRequireTosBeforePlans = 'options.requireTosBeforePlans',
  OptionsSetupCheckoutText = 'options.setupCheckoutText',
  OptionsShowContactSupport = 'options.showContactSupport',
  OptionsContactSupportLink = 'options.contactSupportLink',
  OptionsTermsOfServiceUrl = 'options.termsOfServiceUrl',
  OptionsPrivacyPolicyUrl = 'options.privacyPolicyUrl',
  OptionsBrandingPrimaryColor = 'options.branding.primaryColor',
  OptionsBrandingSecondaryColor = 'options.branding.secondaryColor',
  OptionsBrandingBannerColor = 'options.branding.bannerColor',
  OptionsBrandingPageBlock1Color = 'options.branding.pageBlock1Color',
  OptionsBrandingBackgroundImageUrl = 'options.branding.backgroundImageUrl',
}

export interface PlansTabBrandingValues {
  primaryColor: string;
  secondaryColor: string;
  bannerColor: string;
  pageBlock1Color: string;
  backgroundImageUrl: string;
}

export const DEFAULT_BRANDING_VALUES: PlansTabBrandingValues = {
  primaryColor: '#2563eb',
  secondaryColor: '#2563eb',
  bannerColor: '#2563eb',
  pageBlock1Color: '#f9fafb',
  backgroundImageUrl: '',
};

export interface PlansTabBillingOptionsValues {
  monthlyEnabled: boolean;
  annualEnabled: boolean;
}

export interface PlansTabPlanValues {
  id: string;
  name: string;
  enabled: boolean;
  mostPopular: boolean;
  callForPricing: boolean;
  monthlyPrice: string;
  annualPrice: string;
  sortOrder: number;
  platformSlaId?: string | null;
}

export interface PlansTabFeatureValues {
  id: string;
  name: string;
  defaultContent: string;
  defaultTooltip: string;
  includedPlanIds: string[];
  overrideContentByPlanId: Record<string, string>;
  overrideTooltipByPlanId: Record<string, string>;
  sortOrder: number;
}

export interface PlansTabFaqQuestionValues {
  id: string;
  question: string;
  answer: string;
  sortOrder: number;
}

export interface PlansTabOptionsValues {
  showFaq: boolean;
  faqQuestions: PlansTabFaqQuestionValues[];
  showSkipPriceSelection: boolean;
  requireTosBeforePlans: boolean;
  setupCheckoutText: string;
  showContactSupport: boolean;
  contactSupportLink: string;
  termsOfServiceUrl: string;
  privacyPolicyUrl: string;
  branding: PlansTabBrandingValues;
}

export interface PlansTabFormValues {
  billingOptions: PlansTabBillingOptionsValues;
  plans: PlansTabPlanValues[];
  features: PlansTabFeatureValues[];
  options: PlansTabOptionsValues;
}

export const createNewPlan = (): PlansTabPlanValues => ({
  id: crypto.randomUUID(),
  name: 'New plan',
  enabled: false,
  mostPopular: false,
  callForPricing: false,
  monthlyPrice: '',
  annualPrice: '',
  sortOrder: 0,
});

export const createNewFeature = (sortOrder = 0): PlansTabFeatureValues => ({
  id: crypto.randomUUID(),
  name: '',
  defaultContent: '',
  defaultTooltip: '',
  includedPlanIds: [],
  overrideContentByPlanId: {},
  overrideTooltipByPlanId: {},
  sortOrder,
});

export const createNewFaqQuestion = (sortOrder = 0): PlansTabFaqQuestionValues => ({
  id: crypto.randomUUID(),
  question: '',
  answer: '',
  sortOrder,
});

export const DEFAULT_PLANS_TAB_VALUES: PlansTabFormValues = {
  billingOptions: {
    monthlyEnabled: true,
    annualEnabled: true,
  },
  plans: [],
  features: [],
  options: {
    showFaq: false,
    faqQuestions: [],
    showSkipPriceSelection: false,
    requireTosBeforePlans: false,
    setupCheckoutText: '',
    showContactSupport: false,
    contactSupportLink: '',
    termsOfServiceUrl: '',
    privacyPolicyUrl: '',
    branding: { ...DEFAULT_BRANDING_VALUES },
  },
};
export enum ExpandedSection {
  Billing = 'billing',
  Plans = 'plans',
  Features = 'features',
  Faq = 'faq',
  CtaSupport = 'cta-support',
}
